import { type InferOutput, minLength, object, pipe, string } from 'valibot'

import { VALIDATION_MESSAGES } from '@/constants/common/validation.constants'

export type ShipmentCategoriesFormValue = {
  name: string
  code: string
  displayColor: string
}

export const CreateShipmentCategoriesDtoSchema = object({
  name: pipe(string(), minLength(1, VALIDATION_MESSAGES.REQUIRED_ITEM)), // 配送種別名
  code: pipe(string(), minLength(1, VALIDATION_MESSAGES.REQUIRED_ITEM)), // 配送種別コード
  displayColor: pipe(string(), minLength(1, VALIDATION_MESSAGES.REQUIRED_ITEM)) // 配送種別カラー
})

export type CreateShipmentCategoriesDto = InferOutput<
  typeof CreateShipmentCategoriesDtoSchema
>

export const initialShipmentCategoriesFormValue: ShipmentCategoriesFormValue = {
  name: '',
  code: '',
  displayColor: '#FA541C'
}
